import { render, staticRenderFns } from "./addInstitucion.vue?vue&type=template&id=01292e81&scoped=true"
import script from "./addInstitucion.vue?vue&type=script&lang=js"
export * from "./addInstitucion.vue?vue&type=script&lang=js"
import style0 from "./addInstitucion.vue?vue&type=style&index=0&id=01292e81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01292e81",
  null
  
)

export default component.exports